<template>
    <el-col >
        <el-col :span="20" :push="2">
            <br />
            <el-card>
                <div slot="header" class="clearfix">
                    <h3 style="color: chocolate;">User-Derived Significant Genes</h3>
                </div>
                <div class="mt-3">
                <span class="font-weight-bold">Job Basic Information</span>

                <el-descriptions :column="2" border labelClassName="labelClassName">
                    <el-descriptions-item label="rsID Identifier">
                        <el-tag type="success">{{ preConf.rsid }}</el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="P-Value Identifier">
                        <el-tag color="#ff0">{{ preConf.pvalue }}</el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="Beta Identifier">
                        <span>{{ preConf.beta }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="Non Effect Allele Identifier">
                        <span>{{ preConf.nonEffectAllele }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="Chromosome Identifier">
                        <span>{{ preConf.chromosome }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="Effect Allele Identifier">
                        <span>{{ preConf.effectAllele }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="Genomic Position Identifier">
                        <span>{{ preConf.genomicPosition }}</span>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <br />

            <!-- <div class="mt-3">
                <span class="font-weight-bold">Output</span>
                <pre>{{ jobInfo.output }}</pre>
            </div> -->

            <div v-if="jobInfo.statisticsType == 'tissue'">
                <span class="font-weight-bold">Job Results</span>
                <el-row gutter="30">
                    <el-col span="8" >
                        <el-card
                            shadow="never"
                        >
                            <el-table
                                border
                                empty-text="Empty data"
                                :data="resultInfo.tissueResults1"
                                style="width: 100%">
                                <el-table-column
                                    prop="p005"
                                    label="P < 0.05"
                                    width="180">
                                    <template slot-scope="scope">
                                        <span  v-if="scope.row.p005 >= 0.05">{{scope.row.p005}}</span>
                                        <span style="color: pink" v-if="scope.row.p005 < 0.05 && scope.row.p005 >= 0.005">{{scope.row.p005}}</span>
                                        <span style="color: red" v-if="scope.row.p005 < 0.005">{{scope.row.p005}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="p001"
                                    label="P < 0.01"
                                    width="180">
                                    <template slot-scope="scope">
                                        <span  v-if="scope.row.p001 >= 0.05">{{scope.row.p001}}</span>
                                        <span style="color: pink" v-if="scope.row.p001 < 0.05 && scope.row.p001 >= 0.005">{{scope.row.p001}}</span>
                                        <span style="color: red" v-if="scope.row.p001 < 0.005">{{scope.row.p001}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="name"
                                    label="Name">
                                </el-table-column>
                            </el-table>
                        </el-card>
                    </el-col>
                    <el-col span="8">
                        <el-card>
                            <el-table
                                border
                                empty-text="Empty data"
                                :data="resultInfo.tissueResults2"
                                style="width: 100%">
                                <el-table-column
                                    prop="p005"
                                    label="P < 0.05"
                                    width="180">
                                    <template slot-scope="scope">
                                        <span  v-if="scope.row.p005 >= 0.05">{{scope.row.p005}}</span>
                                        <span style="color: pink" v-if="scope.row.p005 < 0.05 && scope.row.p005 >= 0.005">{{scope.row.p005}}</span>
                                        <span style="color: red" v-if="scope.row.p005 < 0.005">{{scope.row.p005}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="p001"
                                    label="P < 0.01"
                                    width="180">
                                    <template slot-scope="scope">
                                        <span  v-if="scope.row.p001 >= 0.05">{{scope.row.p001}}</span>
                                        <span style="color: pink" v-if="scope.row.p001 < 0.05 && scope.row.p001 >= 0.005">{{scope.row.p001}}</span>
                                        <span style="color: red" v-if="scope.row.p001 < 0.005">{{scope.row.p001}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="name"
                                    label="Name">
                                </el-table-column>
                            </el-table>
                        </el-card>
                    </el-col>
                    <el-col span="8">
                        <el-card>
                            <el-table
                                border
                                empty-text="Empty data"
                                :data="resultInfo.tissueResults3"
                                style="width: 100%">
                                <el-table-column
                                    prop="p005"
                                    label="P < 0.05"
                                    width="180">
                                    <template slot-scope="scope">
                                        <span  v-if="scope.row.p005 >= 0.05">{{scope.row.p005}}</span>
                                        <span style="color: pink" v-if="scope.row.p005 < 0.05 && scope.row.p005 >= 0.005">{{scope.row.p005}}</span>
                                        <span style="color: red" v-if="scope.row.p005 < 0.005">{{scope.row.p005}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="p001"
                                    label="P < 0.01"
                                    width="180">
                                    <template slot-scope="scope">
                                        <span  v-if="scope.row.p001 >= 0.05">{{scope.row.p001}}</span>
                                        <span style="color: pink" v-if="scope.row.p001 < 0.05 && scope.row.p001 >= 0.005">{{scope.row.p001}}</span>
                                        <span style="color: red" v-if="scope.row.p001 < 0.005">{{scope.row.p001}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="name"
                                    label="Name">
                                </el-table-column>
                            </el-table>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
            <br />

            <div v-if="jobInfo.statisticsType == 'twas'">
                <span class="font-weight-bold">Job Results</span>

                <br />
                <p style="text-align: center; font-size: 22px;"><b>Manhattan Plot (Users can obtain more information about the associations by hovering their mouse over the dots representing each gene)</b></p>
                <br />

                <div class="echarts-tool">
                    <div class="tool-item">
                        <div class="label">Enable Display Gene Label</div>
                        <div>
                            <el-switch v-model="showTooltip" @change="handleShowLegend" />
                        </div>
                    </div>

                </div>

                <div class="echarts-scatter">
                    <div style="width: 100%; height: 100%" ref="scatter"></div>
                </div>

                <br />
                <el-card
                        shadow="never"
                    >
                        <el-table
                            border
                            empty-text="Empty data"
                            :data="resultInfo.twasResults.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                            style="width: 100%">
                            <el-table-column
                                prop="geneSymbol"
                                label="Gene Symbol">
                            </el-table-column>
                            <el-table-column
                                prop="geneName"
                                label="Gene Fullname">
                                <template slot-scope="scope">
                                    <span >{{scope.row.geneName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="geneBioType"
                                label="Gene Biotype">
                            </el-table-column>
                            <el-table-column
                                prop="ensg"
                                label="Ensg">
                            </el-table-column>
                            <el-table-column
                                prop="geneSynonym"
                                label="Gene Synonym">
                            </el-table-column>
                            <el-table-column
                                prop="chromosome"
                                label="Chromosome">
                            </el-table-column>
                            <el-table-column
                                prop="startPos"
                                label="Start Pos">
                            </el-table-column>
                            <el-table-column
                                prop="endPos"
                                label="End Pos">
                            </el-table-column>
                            <el-table-column
                                prop="method"
                                label="Method">
                            </el-table-column>
                            <el-table-column
                                prop="pvalue"
                                label="P-Value">
                            </el-table-column>
                            <el-table-column
                                prop="additionalInfo"
                                label="Additional Info">
                            </el-table-column>
                        </el-table>
                        <br />
                        <el-pagination
                            @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,20]"
                            :page-size="pageSize" layout="total, sizes, prev, pager, next"
                            :total="resultInfo.twasResults.length"
                        >
                        </el-pagination>
                    </el-card>
            </div>
            </el-card>
            <br />

            <el-card>
                <div slot='header'>
                    <h3 style="color: chocolate;">Resource-Derived Significant Genes <el-tooltip content='"Resource-Derived Significant Genes" refers to a curated collection of gene association data for various traits, meticulously compiled from an extensive array of previously collected GWAS summary statistics within the GENEasso resource. This dataset is crucial for replication efforts, as it allows researchers to confirm the consistency and reliability of their findings against a backdrop of established associations. The ability to compare current results with this resource-derived data is essential for reinforcing the validity of new discoveries and for enhancing the overall robustness of research.'>
                        <i class="el-icon-question i-button" style="color: black" />
                    </el-tooltip></h3>

                </div>
                <div class="container-trait">
                <div class="traTitle">
                    <h3>{{ detailInfo.efoOntologyTrait }}</h3>
                </div>
                <div class="title">Trait information</div>
                    <table class="table table-bordered table-hover">
                        <tbody>
                            <tr>
                                <td>Trait Label</td>
                                <td>{{ detailInfo.efoOntologyTrait }}</td>
                            </tr>
                            <tr>
                                <td>Ontology ID</td>
                                <td>
                                    <a :href="detailInfo.efoCode?.indexOf('EFO:') >= 0 ? 'http://www.ebi.ac.uk/efo/' + detailInfo.efoCode?.replaceAll(':', '_') : 'http://purl.obolibrary.org/obo/' + detailInfo.efoCode?.replaceAll(':', '_')">{{ detailInfo.efoCode }}</a>
                                </td>
                            </tr>
                            <tr>
                                <td>Description</td>
                                <td>{{ detailInfo.description != 'skip' ? detailInfo.description : '' }}</td>
                            </tr>
                            <tr>
                                <td>Trait Type</td>
                                <td>{{ detailInfo.traitType }}</td>
                            </tr>
                            <tr>
                                <td>Synonyms</td>
                                <td>{{ detailInfo.synonym }}</td>
                            </tr>
                            <tr>
                                <td>More Trait Information</td>
                                <td>
                                    <a :href="detailInfo.efoCode?.indexOf('EFO:') >= 0 ? 'http://www.ebi.ac.uk/efo/' + detailInfo.efoCode?.replaceAll(':', '_') : 'http://purl.obolibrary.org/obo/' + detailInfo.efoCode?.replaceAll(':', '_')">EFO Trait</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="tableT">All GWAS Summary Statistics associated with the trait</div>

                    <div>
                        <trait_summary :trait-id="traitId" />
                    </div>

                    <br />

                    <div class="tableT">Genes associated with the trait</div>
                    <div>
                        <trait_gene :trait-id="traitId" />
                    </div>

                </div>
            </el-card>

            <br />

        </el-col>
    </el-col>
</template>

<script>
import Trait_summary from "@/views/trait/trait_summary";
import Trait_gene from "@/views/trait/trait_gene";
import Trait_snp from "@/views/trait/trait_snp";

let timer = null;

const chrMap = {
    1: 248849517,
    2: 242078722,
    3: 198148238,
    4: 188147743,
    5: 181272307,
    6: 170572870,
    7: 159154430,
    8: 145066685,
    9: 138124624,
    10: 133569835,
    11: 134319564,
    12: 133235877,
    13: 114337626,
    14: 106368436,
    15: 101806887,
    16: 90095932,
    17: 83095122,
    18: 80247514,
    19: 58573575,
    20: 64304820,
    21: 46665124,
    22: 50783667,
};

const zoomOut = 500000;
let xAxisLabel = {};

const chrTotal = Object.values(chrMap).reduce(function (pre, cur, i) {
    xAxisLabel[i + 1] = pre + cur;
    return pre + cur;
}, 0);

function getDotPosX(dot) {
    let posX = xAxisLabel[dot.chr - 1] || 0;
    posX += dot.start;

    return Math.floor(posX / zoomOut);
}

let _data = [];
let echarts = null;

export default {
    name: "results",
    components: {
        Trait_gene,
        Trait_summary,
    },
    data() {
        return {
            jobId: this.$route.query.jobId || "",
            traitId: this.$route.query.traitId || '',
            showWarningText: false,
            jobInfo: {
                name: "",
                jobId: "",
                email: "",
                methods: [],
                preConf: {
                    rsid: "",
                    beta: "",
                    pvalue: "",
                    effectAllele: "",
                    nonEffectAllele: "",
                    sampleSize: "",
                    chromosome: "",
                    genomicPosition: "",
                    ancestry: "",
                    includingUkbb: "",
                    sexSpecific: "",
                    separator: "",
                    attachmentId: "",
                },
                createTime: "",
                updateTime: "",
                status: "",
                exitCode: "",
                progress: 0,
                output: "",
            },
            resultInfo: {
                resultList: [],
                tissueResults: [],
                twasResults: [],
                tissueResults1: [],
                tissueResults2: [],
                tissueResults3: []
            },
            preConf: {},
            total: 0,
            currentPage: 1,
            pageSize: 10,
            showTooltip: true,
            showComparision: false,
            traitOption: [],
            detailInfo: {},
            compareResults: []
        };
    },

    created() {
        this.getJobInfo();
        this.getTrait()
        this.getManhatton();
    },

    mounted() {
    },

    methods: {
        // 获取数据
        async getJobInfo() {
            const res = await this.$ajax.get(`/job/${this.jobId}`);
            if (res.code !== 200) {
                this.$message.error(res.message);
                return;
            }
            this.jobInfo = res.data;
            this.preConf = this.jobInfo.preConf;
            console.log(this.jobInfo)

            if (this.jobInfo.status == 4 || this.jobInfo.status == 5) {
                return;
            }

            // 状态等于xx则不轮询
            if (this.jobInfo.status == 0 || this.jobInfo.status == 1 || this.jobInfo.status == 2) {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    this.getJobInfo();
                }, 1000 * 10);

                return;
            }

            const taskResult = await this.$ajax.get(`/job/${this.jobId}/result`);
            if (taskResult.code !== 200) {
                this.$message.error(taskResult.message);
                return;
            }
            this.resultInfo = taskResult.data;

            if (this.jobInfo.statisticsType == 'tissue') {
                this.resultInfo.tissueResults1 = []
                this.resultInfo.tissueResults2 = []
                this.resultInfo.tissueResults3 = []
            } else {
            }
        },

        handleShowLegend() {
            this.draw();
        },

        async getManhatton() {
            const res = await this.$ajax.get(`/job/${this.jobId}/compare?traitId=${this.traitId}`);
            if (res.code != 200) {
                this.$message.error(taskResult.message);
                return;
            }

            _data = res.data
            this.draw()
        },

        async getTrait() {
            let res = await this.$ajax.get(`trait/${this.traitId}`);
            this.detailInfo = res.data;
        },

        draw() {
            if (!echarts) {
                echarts = this.$echarts.init(this.$refs.scatter);
            }
            let dataTypeMap = {
                // Variant: [],
            };

            _data.forEach((v) => {
                v.method = v.method.slice(0, 1).toUpperCase() + v.method.slice(1);
                if (!dataTypeMap[v.method]) {
                    dataTypeMap[v.method] = [];
                }
                dataTypeMap[v.method].push({
                    name: v.method,
                    value: [getDotPosX(v), v.y],
                    _extend: v,
                });
            });

            const dataTypeMapKeyArr = Object.keys(dataTypeMap);
            const data = dataTypeMapKeyArr.map((key) => {
                return {
                    name: key,
                    type: "scatter",
                    symbol: (key.indexOf('Archival') >= 0 ? 'circle' : "rect") || null,
                    // 圆的大小
                    symbolSize: 9,
                    // 圆的标签
                    label: {
                        show: this.showTooltip,
                        position: "top",
                        formatter: function (params) {
                            const data = params.data._extend;
                            return data.name;
                        },
                    },
                    data: dataTypeMap[key],
                };
            });

            const option = {
                color: [
                    "#5470c6",
                    "#91cc75",
                    "#fac858",
                    "#ee6666",
                    "#73c0de",
                    "#3ba272",
                    "#fc8452",
                    "#9a60b4",
                    "#ea7ccc",
                    "#4962FC",
                    "#4B7CF3",
                    "#dd3ee5",
                    "#12e78c",
                    "#fe8104",
                    "#01C2F9",
                    "#F4CB29",
                    "#FD9E06",
                ],
                grid: {
                    top: 100,
                    right: 50,
                },
                legend: {
                    show: true,
                    // data: dataTypeMapKeyArr,
                    data: Object.keys(dataTypeMap),
                    top: 5,
                    left: "10%",
                    textStyle: {
                        fontSize: 20,
                    },
                },
                tooltip: {
                    show: true,
                    formatter: function (params) {
                        // params.value[0]  x轴 数据
                        // params.value[1]  y轴 数据

                        const results = [];

                        const _extend = params.data._extend;
                        if (_extend.description) {
                            const lines = _extend.description.split("\n");
                            lines.forEach((it) => {
                                const splits = it.split(";");
                                splits.forEach((split) => {
                                    results.push(split);
                                });
                            });
                        }

                        return results.join("<br />");
                    },
                },
                xAxis: {
                    show: true,
                    name: "Genomic Position(number denotes chromosome)",
                    nameGap: 25,
                    nameLocation: "center",
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    minInterval: 1,
                    // maxInterval: 1,
                    max: Math.floor((chrTotal + zoomOut) / zoomOut),
                    min: 1,
                    interval: 1,
                    axisLabel: {
                        show: true,
                        formatter: (value) => {
                            let i = Object.values(xAxisLabel)
                                .map((v, _i) => v - chrMap[_i + 1] / 2)
                                .map((v) => Math.floor(v / zoomOut))
                                .indexOf(value);
                            return i + 1 || "";
                        },
                    },
                    splitNumber: 0,
                    nameTextStyle: {
                        fontSize: 15,
                    },
                },
                yAxis: {
                    show: true,
                    name: "-log10 P-value",
                    nameGap: 30,
                    max: 50,
                    nameLocation: "center",
                    nameTextStyle: {
                        fontSize: 15,
                    },
                },
                series: data,
            };

            echarts.setOption(option);
        },

        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.currentPage = 1;
            this.pageSize = val;
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.currentPage = val;
        },

        handleShowWarningText() {
            this.showWarningText = !this.showWarningText;
        },

        handleComparision() {
            this.showComparision = true;
        },

        // Trait
        async handleGetTrait(value) {
            const params = {
                keyword: value,
                pageSize: 20,
            };
            let res = await this.$ajax.get("trait/search/page", params);
            const data = res.data.records || [];
            this.traitOption = data.map((v) => {
                return {
                    // 用于显示的名称
                    label: v.efoOntologyTrait,
                    value: v.id,
                };
            });
        },

        handleCompareConfirm() {
            this.showComparision = false;
        }
    },
};
</script>

<style lang="less" scoped>
.title {
    margin-bottom: 15px;
    font-size: 20px;
    font-weight: bold;
}


.font-weight-bold {
    font-size: 20px;
    font-weight: bold;
}
.el-form-item {
    margin: 0;

    /deep/.el-form-item__label {
        font-size: 18px;
    }
}

pre {
    background: #606266;
    width: 75%;
    height: 250px;
    overflow: auto;
    color: #ffffff;
    border-radius: 8px;
    padding: 10px 15px;
}


.echarts-scatter {
    width: 100%;
    height: 800px;
}

.echarts-tool {
    display: flex;
    margin: 10px 0 15px;
    justify-content: center;

    .tool-item {
        display: flex;
        align-items: center;
        margin-right: 15px;
    }

    .label {
        font-weight: normal;
        font-size: 18px;
        color: #333333;
        padding: 0;
        margin: 0 5px 0 0;
    }
}

/deep/ .labelClassName {
    width: 200px;
}
</style>
